function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _class, _temp;

var _require = require('@uppy/core'),
    UIPlugin = _require.UIPlugin;

var _require2 = require('preact'),
    h = _require2.h;

var Editor = require('./Editor');

var locale = require('./locale.js');

module.exports = (_temp = _class = /*#__PURE__*/function (_UIPlugin) {
  _inherits(ImageEditor, _UIPlugin);

  var _super = _createSuper(ImageEditor);

  // eslint-disable-next-line global-require
  function ImageEditor(uppy, opts) {
    var _this;

    _classCallCheck(this, ImageEditor);

    _this = _super.call(this, uppy, opts);

    _this.save = function () {
      var saveBlobCallback = function saveBlobCallback(blob) {
        var _this$getPluginState = _this.getPluginState(),
            currentImage = _this$getPluginState.currentImage;

        _this.uppy.setFileState(currentImage.id, {
          data: blob,
          size: blob.size,
          preview: null
        });

        var updatedFile = _this.uppy.getFile(currentImage.id);

        _this.uppy.emit('thumbnail:request', updatedFile);

        _this.setPluginState({
          currentImage: updatedFile
        });

        _this.uppy.emit('file-editor:complete', updatedFile);
      };

      var _this$getPluginState2 = _this.getPluginState(),
          currentImage = _this$getPluginState2.currentImage;

      _this.cropper.getCroppedCanvas(_this.opts.cropperOptions.croppedCanvasOptions).toBlob(saveBlobCallback, currentImage.type, _this.opts.quality);
    };

    _this.storeCropperInstance = function (cropper) {
      _this.cropper = cropper;
    };

    _this.selectFile = function (file) {
      _this.uppy.emit('file-editor:start', file);

      _this.setPluginState({
        currentImage: file
      });
    };

    _this.id = _this.opts.id || 'ImageEditor';
    _this.title = 'Image Editor';
    _this.type = 'editor';
    _this.defaultLocale = locale;
    var defaultCropperOptions = {
      viewMode: 1,
      background: false,
      autoCropArea: 1,
      responsive: true,
      croppedCanvasOptions: {}
    };
    var defaultActions = {
      revert: true,
      rotate: true,
      granularRotate: true,
      flip: true,
      zoomIn: true,
      zoomOut: true,
      cropSquare: true,
      cropWidescreen: true,
      cropWidescreenVertical: true
    };
    var defaultOptions = {
      quality: 0.8
    };
    _this.opts = _objectSpread(_objectSpread(_objectSpread({}, defaultOptions), opts), {}, {
      actions: _objectSpread(_objectSpread({}, defaultActions), opts.actions),
      cropperOptions: _objectSpread(_objectSpread({}, defaultCropperOptions), opts.cropperOptions)
    });

    _this.i18nInit();

    return _this;
  } // eslint-disable-next-line class-methods-use-this


  _createClass(ImageEditor, [{
    key: "canEditFile",
    value: function canEditFile(file) {
      if (!file.type || file.isRemote) {
        return false;
      }

      var fileTypeSpecific = file.type.split('/')[1];

      if (/^(jpe?g|gif|png|bmp|webp)$/.test(fileTypeSpecific)) {
        return true;
      }

      return false;
    }
  }, {
    key: "install",
    value: function install() {
      this.setPluginState({
        currentImage: null
      });
      var target = this.opts.target;

      if (target) {
        this.mount(target, this);
      }
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      this.unmount();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$getPluginState3 = this.getPluginState(),
          currentImage = _this$getPluginState3.currentImage;

      if (currentImage === null || currentImage.isRemote) {
        return null;
      }

      return h(Editor, {
        currentImage: currentImage,
        storeCropperInstance: this.storeCropperInstance,
        save: this.save,
        opts: this.opts,
        i18n: this.i18n
      });
    }
  }]);

  return ImageEditor;
}(UIPlugin), _class.VERSION = "1.1.1", _temp);